// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"65cd094e","453":"2bafbd89"}[chunkId] + ".chunk.js";
};